import { motion } from "framer-motion";
import { useLang } from "@/i18n";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] },
});

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="relative py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <motion.div {...reveal()} className="lg:col-span-5">
            <div className="font-mono-alt mb-4 text-xs uppercase tracking-[0.25em] text-blue-700">
              {t.about.eyebrow}
            </div>
            <h2
              data-testid="about-title"
              className="font-display text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl lg:leading-[1.15]"
            >
              {t.about.title} <span className="text-glow-gradient">{t.about.titleAccent}</span>
            </h2>
          </motion.div>

          <motion.div {...reveal(0.15)} className="space-y-6 lg:col-span-7">
            <p data-testid="about-p1" className="text-base font-normal leading-relaxed text-slate-700 sm:text-lg">
              {t.about.p1}
            </p>
            <p data-testid="about-p2" className="text-base font-normal leading-relaxed text-slate-700 sm:text-lg">
              {t.about.p2}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
